export default __webpack_public_path__ + "static/media/JLLHeaderLogo.bb9b4548.png";